<template>
  <div class="cmp-wrapper">
    <basic-container>
      <p class="title">人员信息</p>
      <add-dialog @success="getPersonnelList"></add-dialog>
      <el-table :data="tableData">
        <el-table-column label="人员姓名" prop="memberName" align="center"></el-table-column>
        <el-table-column label="绑定手机号" prop="phone" align="center"></el-table-column>
        <el-table-column label="关联门店" align="center">
          <template slot-scope="scope">
            <div v-for="item in scope.row.stores" :key="item">{{item.name}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-radio v-model="radio" :label="scope.row.id">关联</el-radio>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-button size="mini" @click="handleBack">取消</el-button>
        <el-button size="mini" type="primary" @click="handleSubmit">保存并提交</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import addDialog from "./addDiglog";
export default {
  components: {
    addDialog
  },
  name: "add-personnel",
  data() {
    return {
      tableData: [],
      radio: 0
    };
  },
  created() {
    this.getPersonnelList();
  },
  methods: {
    async getPersonnelList() {
      const { ret, data } = await _api.member.getPersonnelList();
      if (ret && data) {
        this.tableData = data;
      }
    },
    handleBack() {
      this.$router.push("/storeManagement/list");
    },
    async handleSubmit() {
      const { ret, data } = await _api.member.addStore({
        storeIds: [this.$route.query.storeId],
        memberId: this.radio,
        storeList: [{
          storeId: this.$route.query.storeId,
          roleId: 5
        }]
      });
      if (ret && data) {
        this.$message({
          type: 'success',
          message: '关联成功！'
        })
        this.$router.push("/storeManagement/list");
      }
    }
  }
};
</script>

<style scoped>
.title {
  font-weight: 900;
  font-size: 18px;
}
</style>